import script from "./Portfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./Portfolio.vue?vue&type=script&setup=true&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=5fbe2a86&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fbe2a86"]])

export default __exports__